/**
 * /eric/onboarding — operator onboarding review queue (T-035).
 *
 * PRD-003 PR-07, DES-12, GTM-10, US-05. Operator-only.
 *
 * The `beforeLoad` guard stays here (non-lazy) so it runs at navigation time,
 * before the component chunk is fetched. Component lives in
 * eric.onboarding.lazy.tsx.
 *
 * Historical note: this route once carried a direct `requireOperator` guard
 * because eric.tsx was a frozen leaf stub with no Outlet. eric.tsx is now a
 * layout route with its own `requireOperatorEntry` guard, so this inner guard
 * is belt-and-suspenders. It stays because removing it requires a separate
 * audit of the guard chain.
 */

import { createFileRoute } from '@tanstack/react-router';
import { requireOperator } from '@/lib/route-guards';

export const Route = createFileRoute('/eric/onboarding')({
  beforeLoad: async ({ location }) => {
    await requireOperator({ redirectFrom: location.pathname });
  },
});
